<template>
  <div class="app-container">
    <Title :data="data"></Title>
    <Batch
      title="讲义"
      text="讲义"
      :list="this.form.handout"
      :isBtn="true"
      style="margin-bottom: 20px"
      @refresh="getDetail()"
    />
    <Batch
      title="教案"
      text="教案"
      :list="this.form.lesson_plan"
      :isBtn="true"
      style="margin-bottom: 20px"
      @refresh="getDetail()"
    />
    <Batch
      title="音频/视频"
      text="音频/视频"
      :list="this.form.video_audio"
      :isBtn="true"
      style="margin-bottom: 20px"
      @refresh="getDetail()"
    />
    <div style="display: flex; justify-content: center">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <el-dialog
      title="批量操作"
      :visible.sync="batchAuthDialogVisible"
      width="60%"
      @close="handleClose"
    >
      <el-form ref="form" label-width="100px">
        <el-form-item label="原因">
          <el-input
            v-model="rejectReason"
            :placeholder="`请输入原因`"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="batchAuthBtnLoading"
            @click="handleBatchAuth(1)"
            >通过</el-button
          >
          <el-button
            type="warning"
            :loading="batchAuthBtnLoading"
            @click="handleBatchAuth(2)"
            >驳回</el-button
          >
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Batch from "@/components/Batch/index.vue";
import request from "@/utils/request";
export default {
  components: {
    Batch,
  },
  data() {
    return {
      data: {},
      form: {},
      listQuery: {
        page: 1,
        limit: 10,
        type: null,
        class_course_id: null,
      },
      selected: false,
      batchAuthDialogVisible: false,
      batchAuthBtnLoading: false,
      rejectReason: null,
    };
  },
  created() {
    this.data = JSON.parse(this.$route.query.data);
    this.listQuery.type = this.$route.query.type;
    this.listQuery.class_course_id = this.$route.query.class_course_id;
    localStorage.setItem("classdata", JSON.stringify(this.data));

    this.form = {
      handout: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "handout",
        data: [],
      },
      lesson_plan: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "lesson_plan",
        data: [],
      },
      video_audio: {
        id: null,
        class_course_id: this.listQuery.class_course_id,
        type: this.listQuery.type,
        type_key: "video_audio",
        data: [],
      },
    };
    this.getDetail();
  },
  methods: {
    getDetail() {
      request({
        url: "/api/schoolend/eduAdmin/dataDetail",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        if (response.data) {
          this.form = response.data;
          this.$forceUpdate(); //强制更新
        }
      });
    },
    handlerTap(v) {
      this.selected = !this.selected;
    },
    handleBatchAuth() {},
    handleClose() {
      this.batchAuthDialogVisible = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  margin-bottom: 20px;
}
.content {
  width: 50%;
  margin: 0 auto;
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .bottom_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 100px;
  }
  .bottom {
    display: flex;
  }
}
</style>
